// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container {\r\n    margin-top: 10px;\r\n\r\n    font-weight: bold !important;\r\n}\r\n\r\n.container p {\r\n    font-weight: lighter;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.page-content {\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    min-height: 100vh;\r\n    margin-bottom: 20px;\r\n    font-size: 16px;\r\n    line-height: 30px;\r\n}", ""]);
// Exports
module.exports = exports;
